import useBrowserMode from "../shared/hooks/useBrowserMode";

const { window, localStorage } = useBrowserMode();

export const changeFontSize = (action: string, fontSize: any) => {
  if (typeof window !== "undefined") {
    const item = document.querySelector("html")!;

    switch (action) {
      case "+":
        if (fontSize.get < 120) {
          item.style.fontSize = `${fontSize.get + 20}%`;
          fontSize.set(fontSize.get + 20);
        }
        break;
      case "-":
        if (fontSize.get > 80) {
          item.style.fontSize = `${fontSize.get - 20}%`;
          fontSize.set(fontSize.get - 20);
        }
        break;
    }
  }
};

export const scrollToTop = () => {
  window.scrollTo(0, 0);
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

export const showScrollBtn = (scrollBtn: HTMLElement) => {
  scrollBtn.classList.add("fixed-on-internal");

  scrollBtn.style.display =
    document.body.scrollTop > 100 || document.documentElement.scrollTop > 100
      ? "block"
      : "none";
};

export const hasStartSlash = (slug: string) => {
  const reg = new RegExp("^/");
  return slug?.search(reg) === -1 ? `/${slug}` : slug;
};

export const toLocalStoragepageActive = () => {
  if (localStorage?.getItem("Redirection")) {
    const storage: any = localStorage?.getItem("Redirection");
    const data = JSON.parse(storage);
    return data.titleButton === "SOS EMPRESARIO"
      ? false
      : localStorage?.setItem(
          "Redirection",
          JSON.stringify({
            titleButton: "SOS EMPRESARIO",
            path: process.env.GATSBY_PATHPREFIX?.replace("/", ""),
          })
        );
  } else {
    return localStorage.setItem(
      "Redirection",
      JSON.stringify({
        titleButton: "SOS EMPRESARIO",
        path: process.env.GATSBY_PATHPREFIX?.replace("/", ""),
      })
    );
  }
};
